module.exports = __webpack_public_path__ + "img/widget_food.eab896cb.svg";